<template>
  <div
    v-if="incidents.length"
    class="pr-2"
  >
    <incident-card
      v-for="incident in incidents"
      :key="incident.incidentId"
      :incident="incident"
    />
  </div>
</template>

<script>
import IncidentCard from '@/components/IncidentCard'
import incidentServices from '@/api/resources/incident/incidentServices'

export default {
    name: 'PatientIncidentsInfo',
    components: {
        IncidentCard
    },
    props: {
        patientId: { type: Number, required: true }
    },
    data() {
        return {
            incidents: []
        }
    },
    async created() {
        const [err, response] = await this.toCall(incidentServices.getPatientIncidents(this.$store.getters.labId, this.patientId))
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.incidents = response
    }
}

</script>
